import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var AddServiceToCartMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation addToCart($cartRequest: CartRequest!) {\n    addToCart(cartRequest: $cartRequest) {\n      id\n      status\n    }\n  }\n"])));
export default AddServiceToCartMutation;